export type EsCalculatorCategory =
  | "Matemáticas y Álgebra"
  | "Calificaciones y Educación"
  | "Finanzas y Cotidiano"
  | "Salud y Fitness"
  | "Unidades y Física"
  | "Conversión y Geometría"
  | "Estadística y Datos"
  | "Ingeniería y Electrónica"
  | "Química y Ciencia"
  | "Negocios y Productividad";

export interface EsCalculatorMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  description: string;
  category: EsCalculatorCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const ES_CALCULATOR_CATEGORIES: EsCalculatorCategory[] = [
  "Matemáticas y Álgebra",
  "Calificaciones y Educación",
  "Finanzas y Cotidiano",
  "Salud y Fitness",
  "Unidades y Física",
  "Conversión y Geometría",
  "Estadística y Datos",
  "Ingeniería y Electrónica",
  "Química y Ciencia",
  "Negocios y Productividad",
];

export const ES_CALCULATORS: EsCalculatorMeta[] = [
  {
    slug: "matrix-calculator",
    enSlug: "matrix-calculator",
    name: "Calculadora de Matrix",
    tagline: "Calculadora de Matrix online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Matrix. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Grid",
    featured: true,
    keywords: ["calculadora de matrix","matrix calculator","matrix calculator","calculadora online gratis"],
  },
  {
    slug: "logarithm-calculator",
    enSlug: "logarithm-calculator",
    name: "Calculadora de Logarithm & Exponential",
    tagline: "Calculadora de Logarithm & Exponential online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Logarithm & Exponential. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de logarithm & exponential","logarithm & exponential calculator","logarithm calculator","calculadora online gratis"],
  },
  {
    slug: "lcm-gcd-calculator",
    enSlug: "lcm-gcd-calculator",
    name: "Calculadora de LCM & GCD (HCF)",
    tagline: "Calculadora de LCM & GCD (HCF) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de LCM & GCD (HCF). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Hash",
    featured: true,
    keywords: ["calculadora de lcm & gcd (hcf)","lcm & gcd (hcf) calculator","lcm gcd calculator","calculadora online gratis"],
  },
  {
    slug: "trigonometry-calculator",
    enSlug: "trigonometry-calculator",
    name: "Solucionador de Trigonometry & Right Triangle",
    tagline: "Solucionador de Trigonometry & Right Triangle online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Solucionador de Trigonometry & Right Triangle. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Compass",
    featured: true,
    keywords: ["solucionador de trigonometry & right triangle","trigonometry & right triangle solver","trigonometry calculator","calculadora online gratis"],
  },
  {
    slug: "sequence-calculator",
    enSlug: "sequence-calculator",
    name: "Calculadora de Sequence & Series (AP & GP)",
    tagline: "Calculadora de Sequence & Series (AP & GP) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Sequence & Series (AP & GP). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "ListOrdered",
    featured: true,
    keywords: ["calculadora de sequence & series (ap & gp)","sequence & series calculator (ap & gp)","sequence calculator","calculadora online gratis"],
  },
  {
    slug: "percentage-calculator",
    enSlug: "percentage-calculator",
    name: "Calculadora de Percentage",
    tagline: "Calculadora de Percentage online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Percentage. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Percent",
    featured: true,
    keywords: ["calculadora de percentage","percentage calculator","percentage calculator","calculadora online gratis"],
  },
  {
    slug: "grade-calculator",
    enSlug: "grade-calculator",
    name: "Calculadora de Grade & GPA",
    tagline: "Calculadora de Grade & GPA online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Grade & GPA. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculadora de grade & gpa","grade & gpa calculator","grade calculator","calculadora online gratis"],
  },
  {
    slug: "fraction-to-percent-calculator",
    enSlug: "fraction-to-percent-calculator",
    name: "Calculadora de Fraction to Percent",
    tagline: "Calculadora de Fraction to Percent online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Fraction to Percent. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de fraction to percent","fraction to percent calculator","fraction to percent calculator","calculadora online gratis"],
  },
  {
    slug: "attendance-calculator",
    enSlug: "attendance-calculator",
    name: "Calculadora de Attendance Percentage",
    tagline: "Calculadora de Attendance Percentage online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Attendance Percentage. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "UserCheck",
    featured: true,
    keywords: ["calculadora de attendance percentage","attendance percentage calculator","attendance calculator","calculadora online gratis"],
  },
  {
    slug: "discount-calculator",
    enSlug: "discount-calculator",
    name: "Calculadora de Discount & Sales Tax",
    tagline: "Calculadora de Discount & Sales Tax online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Discount & Sales Tax. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Tag",
    featured: true,
    keywords: ["calculadora de discount & sales tax","discount & sales tax calculator","discount calculator","calculadora online gratis"],
  },
  {
    slug: "age-calculator",
    enSlug: "age-calculator",
    name: "Calculadora de Exact Age & Birthday",
    tagline: "Calculadora de Exact Age & Birthday online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Exact Age & Birthday. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Calendar",
    featured: true,
    keywords: ["calculadora de exact age & birthday","exact age & birthday calculator","age calculator","calculadora online gratis"],
  },
  {
    slug: "ratio-calculator",
    enSlug: "ratio-calculator",
    name: "Calculadora de Ratio & Proportion",
    tagline: "Calculadora de Ratio & Proportion online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Ratio & Proportion. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Scale",
    featured: true,
    keywords: ["calculadora de ratio & proportion","ratio & proportion calculator","ratio calculator","calculadora online gratis"],
  },
  {
    slug: "average-calculator",
    enSlug: "average-calculator",
    name: "Calculadora de Average, Median & Mode",
    tagline: "Calculadora de Average, Median & Mode online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Average, Median & Mode. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "BarChart3",
    featured: true,
    keywords: ["calculadora de average, median & mode","average, median & mode calculator","average calculator","calculadora online gratis"],
  },
  {
    slug: "tip-calculator",
    enSlug: "tip-calculator",
    name: "Calculadora de Tip & Bill Splitter",
    tagline: "Calculadora de Tip & Bill Splitter online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Tip & Bill Splitter. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Receipt",
    featured: true,
    keywords: ["calculadora de tip & bill splitter","tip & bill splitter calculator","tip calculator","calculadora online gratis"],
  },
  {
    slug: "time-calculator",
    enSlug: "time-calculator",
    name: "Calculadora de Time & Work Hours",
    tagline: "Calculadora de Time & Work Hours online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Time & Work Hours. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Clock",
    featured: true,
    keywords: ["calculadora de time & work hours","time & work hours calculator","time calculator","calculadora online gratis"],
  },
  {
    slug: "bmi-calculator",
    enSlug: "bmi-calculator",
    name: "Calculadora de BMI & Ideal Weight",
    tagline: "Calculadora de BMI & Ideal Weight online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de BMI & Ideal Weight. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculadora de bmi & ideal weight","bmi & ideal weight calculator","bmi calculator","calculadora online gratis"],
  },
  {
    slug: "interest-calculator",
    enSlug: "interest-calculator",
    name: "Calculadora de Simple & Compound Interest",
    tagline: "Calculadora de Simple & Compound Interest online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Simple & Compound Interest. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de simple & compound interest","simple & compound interest calculator","interest calculator","calculadora online gratis"],
  },
  {
    slug: "cgpa-calculator",
    enSlug: "cgpa-calculator",
    name: "Calculadora de CGPA to Percentage",
    tagline: "Calculadora de CGPA to Percentage online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de CGPA to Percentage. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "Award",
    featured: true,
    keywords: ["calculadora de cgpa to percentage","cgpa to percentage calculator","cgpa calculator","calculadora online gratis"],
  },
  {
    slug: "scientific-notation-calculator",
    enSlug: "scientific-notation-calculator",
    name: "Calculadora de Scientific Notation",
    tagline: "Calculadora de Scientific Notation online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Scientific Notation. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Atom",
    featured: true,
    keywords: ["calculadora de scientific notation","scientific notation calculator","scientific notation calculator","calculadora online gratis"],
  },
  {
    slug: "salary-calculator",
    enSlug: "salary-calculator",
    name: "Calculadora de Salary & Hourly Wage",
    tagline: "Calculadora de Salary & Hourly Wage online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Salary & Hourly Wage. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Wallet",
    featured: true,
    keywords: ["calculadora de salary & hourly wage","salary & hourly wage calculator","salary calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-target-calculator",
    enSlug: "gpa-target-calculator",
    name: "Calculadora de Target GPA",
    tagline: "Calculadora de Target GPA online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Target GPA. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de target gpa","target gpa calculator","gpa target calculator","calculadora online gratis"],
  },
  {
    slug: "loan-calculator",
    enSlug: "loan-calculator",
    name: "Calculadora de Loan Monthly Payment",
    tagline: "Calculadora de Loan Monthly Payment online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Loan Monthly Payment. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "CreditCard",
    featured: true,
    keywords: ["calculadora de loan monthly payment","loan monthly payment calculator","loan calculator","calculadora online gratis"],
  },
  {
    slug: "word-count-calculator",
    enSlug: "word-count-calculator",
    name: "Calculadora de Word & Character Count",
    tagline: "Calculadora de Word & Character Count online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Word & Character Count. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "FileText",
    featured: true,
    keywords: ["calculadora de word & character count","word & character count calculator","word count calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-to-percentage-calculator",
    enSlug: "gpa-to-percentage-calculator",
    name: "Conversor de GPA to Percentage",
    tagline: "Conversor de GPA to Percentage online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Conversor de GPA to Percentage. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "GraduationCap",
    featured: true,
    keywords: ["conversor de gpa to percentage","gpa to percentage converter","gpa to percentage calculator","calculadora online gratis"],
  },
  {
    slug: "pythagorean-theorem-calculator",
    enSlug: "pythagorean-theorem-calculator",
    name: "Calculadora de Pythagorean Theorem",
    tagline: "Calculadora de Pythagorean Theorem online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Pythagorean Theorem. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Triangle",
    featured: true,
    keywords: ["calculadora de pythagorean theorem","pythagorean theorem calculator","pythagorean theorem calculator","calculadora online gratis"],
  },
  {
    slug: "quadratic-formula-calculator",
    enSlug: "quadratic-formula-calculator",
    name: "Solucionador de Quadratic Equation",
    tagline: "Solucionador de Quadratic Equation online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Solucionador de Quadratic Equation. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Variable",
    featured: true,
    keywords: ["solucionador de quadratic equation","quadratic equation solver","quadratic formula calculator","calculadora online gratis"],
  },
  {
    slug: "fuel-cost-calculator",
    enSlug: "fuel-cost-calculator",
    name: "Calculadora de Fuel Cost & Gas Mileage",
    tagline: "Calculadora de Fuel Cost & Gas Mileage online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Fuel Cost & Gas Mileage. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Fuel",
    featured: true,
    keywords: ["calculadora de fuel cost & gas mileage","fuel cost & gas mileage calculator","fuel cost calculator","calculadora online gratis"],
  },
  {
    slug: "margin-calculator",
    enSlug: "margin-calculator",
    name: "Calculadora de Profit Margin & Markup",
    tagline: "Calculadora de Profit Margin & Markup online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Profit Margin & Markup. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "DollarSign",
    featured: true,
    keywords: ["calculadora de profit margin & markup","profit margin & markup calculator","margin calculator","calculadora online gratis"],
  },
  {
    slug: "pace-calculator",
    enSlug: "pace-calculator",
    name: "Calculadora de Running Pace & Speed",
    tagline: "Calculadora de Running Pace & Speed online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Running Pace & Speed. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Timer",
    featured: true,
    keywords: ["calculadora de running pace & speed","running pace & speed calculator","pace calculator","calculadora online gratis"],
  },
  {
    slug: "calorie-calculator",
    enSlug: "calorie-calculator",
    name: "Calculadora de Daily Calorie & BMR",
    tagline: "Calculadora de Daily Calorie & BMR online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Daily Calorie & BMR. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de daily calorie & bmr","daily calorie & bmr calculator","calorie calculator","calculadora online gratis"],
  },
  {
    slug: "water-intake-calculator",
    enSlug: "water-intake-calculator",
    name: "Calculadora de Daily Water Intake",
    tagline: "Calculadora de Daily Water Intake online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Daily Water Intake. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Droplets",
    featured: true,
    keywords: ["calculadora de daily water intake","daily water intake calculator","water intake calculator","calculadora online gratis"],
  },
  {
    slug: "body-fat-calculator",
    enSlug: "body-fat-calculator",
    name: "Calculadora de Body Fat Percentage",
    tagline: "Calculadora de Body Fat Percentage online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Body Fat Percentage. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de body fat percentage","body fat percentage calculator","body fat calculator","calculadora online gratis"],
  },
  {
    slug: "velocity-acceleration-calculator",
    enSlug: "velocity-acceleration-calculator",
    name: "Calculadora de Speed, Velocity & Acceleration",
    tagline: "Calculadora de Speed, Velocity & Acceleration online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Speed, Velocity & Acceleration. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de speed, velocity & acceleration","speed, velocity & acceleration calculator","velocity acceleration calculator","calculadora online gratis"],
  },
  {
    slug: "density-calculator",
    enSlug: "density-calculator",
    name: "Calculadora de Density, Mass & Volume",
    tagline: "Calculadora de Density, Mass & Volume online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Density, Mass & Volume. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Box",
    featured: true,
    keywords: ["calculadora de density, mass & volume","density, mass & volume calculator","density calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-to-letter-calculator",
    enSlug: "gpa-to-letter-calculator",
    name: "Conversor de Percentage to Letter Grade",
    tagline: "Conversor de Percentage to Letter Grade online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Conversor de Percentage to Letter Grade. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "CheckCircle2",
    featured: true,
    keywords: ["conversor de percentage to letter grade","percentage to letter grade converter","gpa to letter calculator","calculadora online gratis"],
  },
  {
    slug: "ideal-weight-calculator",
    enSlug: "ideal-weight-calculator",
    name: "Calculadora de Ideal Body Weight (IBW)",
    tagline: "Calculadora de Ideal Body Weight (IBW) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Ideal Body Weight (IBW). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Heart",
    featured: true,
    keywords: ["calculadora de ideal body weight (ibw)","ideal body weight (ibw) calculator","ideal weight calculator","calculadora online gratis"],
  },
  {
    slug: "macro-calculator",
    enSlug: "macro-calculator",
    name: "Calculadora de Macronutrient Ratio",
    tagline: "Calculadora de Macronutrient Ratio online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Macronutrient Ratio. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Apple",
    featured: true,
    keywords: ["calculadora de macronutrient ratio","macronutrient ratio calculator","macro calculator","calculadora online gratis"],
  },
  {
    slug: "weight-loss-calculator",
    enSlug: "weight-loss-calculator",
    name: "Calculadora de Weight Loss & Target Date Planner",
    tagline: "Calculadora de Weight Loss & Target Date Planner online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Weight Loss & Target Date Planner. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "TrendingDown",
    featured: true,
    keywords: ["calculadora de weight loss & target date planner","weight loss calculator & target date planner","weight loss calculator","calculadora online gratis"],
  },
  {
    slug: "height-calculator",
    enSlug: "height-calculator",
    name: "Calculadora de Child & Adult Height Predictor",
    tagline: "Calculadora de Child & Adult Height Predictor online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Child & Adult Height Predictor. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Ruler",
    featured: true,
    keywords: ["calculadora de child & adult height predictor","child & adult height predictor calculator","height calculator","calculadora online gratis"],
  },
  {
    slug: "height-comparison-calculator",
    enSlug: "height-comparison-calculator",
    name: "Calculadora de Height Comparison (Side by Side)",
    tagline: "Calculadora de Height Comparison (Side by Side) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Height Comparison (Side by Side). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Ruler",
    featured: true,
    keywords: ["calculadora de height comparison (side by side)","height comparison calculator (side by side)","height comparison calculator","calculadora online gratis"],
  },
  {
    slug: "army-body-fat-calculator",
    enSlug: "army-body-fat-calculator",
    name: "Calculadora de US Army Body Fat",
    tagline: "Calculadora de US Army Body Fat online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de US Army Body Fat. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["calculadora de us army body fat","us army body fat calculator","army body fat calculator","calculadora online gratis"],
  },
  {
    slug: "keto-calculator",
    enSlug: "keto-calculator",
    name: "Calculadora de Keto Macro & Net Carb",
    tagline: "Calculadora de Keto Macro & Net Carb online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Keto Macro & Net Carb. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de keto macro & net carb","keto macro & net carb calculator","keto calculator","calculadora online gratis"],
  },
  {
    slug: "height-percentile-calculator",
    enSlug: "height-percentile-calculator",
    name: "Calculadora de Height Percentile (CDC & WHO)",
    tagline: "Calculadora de Height Percentile (CDC & WHO) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Height Percentile (CDC & WHO). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "BarChart2",
    featured: true,
    keywords: ["calculadora de height percentile (cdc & who)","height percentile calculator (cdc & who)","height percentile calculator","calculadora online gratis"],
  },
  {
    slug: "body-surface-area-calculator",
    enSlug: "body-surface-area-calculator",
    name: "Calculadora de Body Surface Area (BSA)",
    tagline: "Calculadora de Body Surface Area (BSA) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Body Surface Area (BSA). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Square",
    featured: true,
    keywords: ["calculadora de body surface area (bsa)","body surface area (bsa) calculator","body surface area calculator","calculadora online gratis"],
  },
  {
    slug: "total-body-water-calculator",
    enSlug: "total-body-water-calculator",
    name: "Calculadora de Total Body Water (TBW)",
    tagline: "Calculadora de Total Body Water (TBW) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Total Body Water (TBW). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Droplet",
    featured: true,
    keywords: ["calculadora de total body water (tbw)","total body water (tbw) calculator","total body water calculator","calculadora online gratis"],
  },
  {
    slug: "healthy-weight-calculator",
    enSlug: "healthy-weight-calculator",
    name: "Calculadora de Healthy Weight & Range Finder",
    tagline: "Calculadora de Healthy Weight & Range Finder online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Healthy Weight & Range Finder. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de healthy weight & range finder","healthy weight calculator & range finder","healthy weight calculator","calculadora online gratis"],
  },
  {
    slug: "ohms-law-calculator",
    enSlug: "ohms-law-calculator",
    name: "Calculadora de Ohm's Law & Power",
    tagline: "Calculadora de Ohm's Law & Power online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Ohm's Law & Power. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de ohm's law & power","ohm's law & power calculator","ohms law calculator","calculadora online gratis"],
  },
  {
    slug: "convert-temperature-calculator",
    enSlug: "convert-temperature-calculator",
    name: "Calculadora de Temperature",
    tagline: "Calculadora de Temperature online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Temperature. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Thermometer",
    featured: true,
    keywords: ["calculadora de temperature","temperature converter calculator","convert temperature calculator","calculadora online gratis"],
  },
  {
    slug: "simple-interest-calculator",
    enSlug: "simple-interest-calculator",
    name: "Calculadora de Simple Interest Loan & Savings",
    tagline: "Calculadora de Simple Interest Loan & Savings online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Simple Interest Loan & Savings. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Coins",
    featured: true,
    keywords: ["calculadora de simple interest loan & savings","simple interest loan & savings calculator","simple interest calculator","calculadora online gratis"],
  },
  {
    slug: "percentage-error-calculator",
    enSlug: "percentage-error-calculator",
    name: "Calculadora de Percentage Error",
    tagline: "Calculadora de Percentage Error online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Percentage Error. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Percent",
    featured: true,
    keywords: ["calculadora de percentage error","percentage error calculator","percentage error calculator","calculadora online gratis"],
  },
  {
    slug: "length-converter-calculator",
    enSlug: "length-converter-calculator",
    name: "Conversor de Length & Distance",
    tagline: "Conversor de Length & Distance online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Conversor de Length & Distance. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Conversión y Geometría",
    icon: "Ruler",
    featured: true,
    keywords: ["conversor de length & distance","length & distance converter","length converter calculator","calculadora online gratis"],
  },
  {
    slug: "area-calculator",
    enSlug: "area-calculator",
    name: "Calculadora de 2D Surface Area",
    tagline: "Calculadora de 2D Surface Area online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de 2D Surface Area. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Conversión y Geometría",
    icon: "Shapes",
    featured: true,
    keywords: ["calculadora de 2d surface area","2d surface area calculator","area calculator","calculadora online gratis"],
  },
  {
    slug: "volume-3d-calculator",
    enSlug: "volume-3d-calculator",
    name: "Calculadora de 3D Volume",
    tagline: "Calculadora de 3D Volume online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de 3D Volume. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Conversión y Geometría",
    icon: "BoxSelect",
    featured: true,
    keywords: ["calculadora de 3d volume","3d volume calculator","volume 3d calculator","calculadora online gratis"],
  },
  {
    slug: "scientific-calculator",
    enSlug: "scientific-calculator",
    name: "Calculadora de Scientific Function",
    tagline: "Calculadora de Scientific Function online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Scientific Function. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Calculator",
    featured: true,
    keywords: ["calculadora de scientific function","scientific function calculator","scientific calculator","calculadora online gratis"],
  },
  {
    slug: "exponent-calculator",
    enSlug: "exponent-calculator",
    name: "Calculadora de Exponent & Power",
    tagline: "Calculadora de Exponent & Power online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Exponent & Power. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Superscript",
    featured: true,
    keywords: ["calculadora de exponent & power","exponent & power calculator","exponent calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-to-4-scale-calculator",
    enSlug: "gpa-to-4-scale-calculator",
    name: "Conversor de Marks & 5-Point to 4.0 GPA",
    tagline: "Conversor de Marks & 5-Point to 4.0 GPA online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Conversor de Marks & 5-Point to 4.0 GPA. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "Award",
    featured: true,
    keywords: ["conversor de marks & 5-point to 4.0 gpa","marks & 5-point to 4.0 gpa converter","gpa to 4 scale calculator","calculadora online gratis"],
  },
  {
    slug: "standard-deviation-calculator",
    enSlug: "standard-deviation-calculator",
    name: "Calculadora de Standard Deviation & Variance",
    tagline: "Calculadora de Standard Deviation & Variance online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Standard Deviation & Variance. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Estadística y Datos",
    icon: "BarChart2",
    featured: true,
    keywords: ["calculadora de standard deviation & variance","standard deviation & variance calculator","standard deviation calculator","calculadora online gratis"],
  },
  {
    slug: "probability-calculator",
    enSlug: "probability-calculator",
    name: "Calculadora de Probability & Odds",
    tagline: "Calculadora de Probability & Odds online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Probability & Odds. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Estadística y Datos",
    icon: "PieChart",
    featured: true,
    keywords: ["calculadora de probability & odds","probability & odds calculator","probability calculator","calculadora online gratis"],
  },
  {
    slug: "npr-ncr-calculator",
    enSlug: "npr-ncr-calculator",
    name: "Calculadora de Permutation & Combination (nPr / nCr)",
    tagline: "Calculadora de Permutation & Combination (nPr / nCr) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Permutation & Combination (nPr / nCr). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Estadística y Datos",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de permutation & combination (npr / ncr)","permutation & combination (npr / ncr) calculator","npr ncr calculator","calculadora online gratis"],
  },
  {
    slug: "resistor-color-code-calculator",
    enSlug: "resistor-color-code-calculator",
    name: "Calculadora de Resistor Color Code",
    tagline: "Calculadora de Resistor Color Code online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Resistor Color Code. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Ingeniería y Electrónica",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de resistor color code","resistor color code calculator","resistor color code calculator","calculadora online gratis"],
  },
  {
    slug: "voltage-drop-calculator",
    enSlug: "voltage-drop-calculator",
    name: "Calculadora de Wire Voltage Drop & Size",
    tagline: "Calculadora de Wire Voltage Drop & Size online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Wire Voltage Drop & Size. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Ingeniería y Electrónica",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de wire voltage drop & size","wire voltage drop & size calculator","voltage drop calculator","calculadora online gratis"],
  },
  {
    slug: "power-factor-calculator",
    enSlug: "power-factor-calculator",
    name: "Calculadora de Power Factor (PF) & kVAR Correction",
    tagline: "Calculadora de Power Factor (PF) & kVAR Correction online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Power Factor (PF) & kVAR Correction. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Ingeniería y Electrónica",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de power factor (pf) & kvar correction","power factor (pf) & kvar correction calculator","power factor calculator","calculadora online gratis"],
  },
  {
    slug: "molarity-calculator",
    enSlug: "molarity-calculator",
    name: "Calculadora de Molarity & Solution Concentration",
    tagline: "Calculadora de Molarity & Solution Concentration online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Molarity & Solution Concentration. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de molarity & solution concentration","molarity & solution concentration calculator","molarity calculator","calculadora online gratis"],
  },
  {
    slug: "ph-calculator",
    enSlug: "ph-calculator",
    name: "Calculadora de pH, pOH & Hydrogen Ion [H+]",
    tagline: "Calculadora de pH, pOH & Hydrogen Ion [H+] online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de pH, pOH & Hydrogen Ion [H+]. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "TestTube",
    featured: true,
    keywords: ["calculadora de ph, poh & hydrogen ion [h+]","ph, poh & hydrogen ion [h+] calculator","ph calculator","calculadora online gratis"],
  },
  {
    slug: "ideal-gas-law-calculator",
    enSlug: "ideal-gas-law-calculator",
    name: "Calculadora de Ideal Gas Law (PV = nRT)",
    tagline: "Calculadora de Ideal Gas Law (PV = nRT) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Ideal Gas Law (PV = nRT). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de ideal gas law (pv = nrt)","ideal gas law (pv = nrt) calculator","ideal gas law calculator","calculadora online gratis"],
  },
  {
    slug: "roi-calculator",
    enSlug: "roi-calculator",
    name: "Calculadora de ROI (Return on Investment)",
    tagline: "Calculadora de ROI (Return on Investment) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de ROI (Return on Investment). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de roi (return on investment)","roi (return on investment) calculator","roi calculator","calculadora online gratis"],
  },
  {
    slug: "cpm-calculator",
    enSlug: "cpm-calculator",
    name: "Calculadora de CPM (Cost Per Mille / Thousand)",
    tagline: "Calculadora de CPM (Cost Per Mille / Thousand) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de CPM (Cost Per Mille / Thousand). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de cpm (cost per mille / thousand)","cpm (cost per mille / thousand) calculator","cpm calculator","calculadora online gratis"],
  },
  {
    slug: "breakeven-calculator",
    enSlug: "breakeven-calculator",
    name: "Calculadora de Breakeven Point & Profit Margin",
    tagline: "Calculadora de Breakeven Point & Profit Margin online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Breakeven Point & Profit Margin. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "DollarSign",
    featured: true,
    keywords: ["calculadora de breakeven point & profit margin","breakeven point & profit margin calculator","breakeven calculator","calculadora online gratis"],
  },
  {
    slug: "mortgage-calculator",
    enSlug: "mortgage-calculator",
    name: "Calculadora de Mortgage & Loan Amortization",
    tagline: "Calculadora de Mortgage & Loan Amortization online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Mortgage & Loan Amortization. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Home",
    featured: true,
    keywords: ["calculadora de mortgage & loan amortization","mortgage & loan amortization calculator","mortgage calculator","calculadora online gratis"],
  },
  {
    slug: "compound-interest-calculator",
    enSlug: "compound-interest-calculator",
    name: "Calculadora de Compound Interest & Savings Growth",
    tagline: "Calculadora de Compound Interest & Savings Growth online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Compound Interest & Savings Growth. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de compound interest & savings growth","compound interest & savings growth calculator","compound interest calculator","calculadora online gratis"],
  },
  {
    slug: "tdee-calculator",
    enSlug: "tdee-calculator",
    name: "Calculadora de TDEE & BMR Calorie",
    tagline: "Calculadora de TDEE & BMR Calorie online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de TDEE & BMR Calorie. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de tdee & bmr calorie","tdee & bmr calorie calculator","tdee calculator","calculadora online gratis"],
  },
  {
    slug: "inflation-calculator",
    enSlug: "inflation-calculator",
    name: "Calculadora de Inflation & Purchasing Power",
    tagline: "Calculadora de Inflation & Purchasing Power online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Inflation & Purchasing Power. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "ArrowDownRight",
    featured: true,
    keywords: ["calculadora de inflation & purchasing power","inflation & purchasing power calculator","inflation calculator","calculadora online gratis"],
  },
  {
    slug: "linear-equations-calculator",
    enSlug: "linear-equations-calculator",
    name: "Solucionador de System of Linear Equations",
    tagline: "Solucionador de System of Linear Equations online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Solucionador de System of Linear Equations. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["solucionador de system of linear equations","system of linear equations solver","linear equations calculator","calculadora online gratis"],
  },
  {
    slug: "vector-calculator",
    enSlug: "vector-calculator",
    name: "Calculadora de 2D & 3D Vector Math",
    tagline: "Calculadora de 2D & 3D Vector Math online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de 2D & 3D Vector Math. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Compass",
    featured: true,
    keywords: ["calculadora de 2d & 3d vector math","2d & 3d vector math calculator","vector calculator","calculadora online gratis"],
  },
  {
    slug: "auto-loan-calculator",
    enSlug: "auto-loan-calculator",
    name: "Calculadora de Auto Loan & Car Payment",
    tagline: "Calculadora de Auto Loan & Car Payment online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Auto Loan & Car Payment. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Car",
    featured: true,
    keywords: ["calculadora de auto loan & car payment","auto loan & car payment calculator","auto loan calculator","calculadora online gratis"],
  },
  {
    slug: "macro-ratio-calculator",
    enSlug: "macro-ratio-calculator",
    name: "Calculadora de Macronutrient & Meal Ratio",
    tagline: "Calculadora de Macronutrient & Meal Ratio online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Macronutrient & Meal Ratio. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Utensils",
    featured: true,
    keywords: ["calculadora de macronutrient & meal ratio","macronutrient & meal ratio calculator","macro ratio calculator","calculadora online gratis"],
  },
  {
    slug: "percentage-change-calculator",
    enSlug: "percentage-change-calculator",
    name: "Calculadora de Percentage Change & Difference",
    tagline: "Calculadora de Percentage Change & Difference online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Percentage Change & Difference. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Percent",
    featured: true,
    keywords: ["calculadora de percentage change & difference","percentage change & difference calculator","percentage change calculator","calculadora online gratis"],
  },
  {
    slug: "fire-calculator",
    enSlug: "fire-calculator",
    name: "Calculadora de FIRE & Retirement Nest Egg",
    tagline: "Calculadora de FIRE & Retirement Nest Egg online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de FIRE & Retirement Nest Egg. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de fire & retirement nest egg","fire & retirement nest egg calculator","fire calculator","calculadora online gratis"],
  },
  {
    slug: "loan-payoff-calculator",
    enSlug: "loan-payoff-calculator",
    name: "Calculadora de Loan Payoff & Extra Payment",
    tagline: "Calculadora de Loan Payoff & Extra Payment online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Loan Payoff & Extra Payment. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Sparkles",
    featured: true,
    keywords: ["calculadora de loan payoff & extra payment","loan payoff & extra payment calculator","loan payoff calculator","calculadora online gratis"],
  },
  {
    slug: "kinetic-energy-calculator",
    enSlug: "kinetic-energy-calculator",
    name: "Calculadora de Kinetic Energy & Momentum Physics",
    tagline: "Calculadora de Kinetic Energy & Momentum Physics online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Kinetic Energy & Momentum Physics. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de kinetic energy & momentum physics","kinetic energy & momentum physics calculator","kinetic energy calculator","calculadora online gratis"],
  },
  {
    slug: "sales-tax-calculator",
    enSlug: "sales-tax-calculator",
    name: "Calculadora de Sales Tax & Reverse Tax",
    tagline: "Calculadora de Sales Tax & Reverse Tax online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Sales Tax & Reverse Tax. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Tag",
    featured: true,
    keywords: ["calculadora de sales tax & reverse tax","sales tax & reverse tax calculator","sales tax calculator","calculadora online gratis"],
  },
  {
    slug: "restaurant-tip-calculator",
    enSlug: "restaurant-tip-calculator",
    name: "Calculadora de Restaurant Tip & Bill Splitter",
    tagline: "Calculadora de Restaurant Tip & Bill Splitter online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Restaurant Tip & Bill Splitter. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Utensils",
    featured: true,
    keywords: ["calculadora de restaurant tip & bill splitter","restaurant tip & bill splitter calculator","restaurant tip calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-conversion-calculator",
    enSlug: "gpa-conversion-calculator",
    name: "Calculadora de GPA, CGPA & 10-Point Scale Conversion",
    tagline: "Calculadora de GPA, CGPA & 10-Point Scale Conversion online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de GPA, CGPA & 10-Point Scale Conversion. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "Award",
    featured: true,
    keywords: ["calculadora de gpa, cgpa & 10-point scale conversion","gpa, cgpa & 10-point scale conversion calculator","gpa conversion calculator","calculadora online gratis"],
  },
  {
    slug: "calorie-deficit-calculator",
    enSlug: "calorie-deficit-calculator",
    name: "Calculadora de Calorie Deficit & Weight Loss Target Date",
    tagline: "Calculadora de Calorie Deficit & Weight Loss Target Date online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Calorie Deficit & Weight Loss Target Date. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de calorie deficit & weight loss target date","calorie deficit & weight loss target date calculator","calorie deficit calculator","calculadora online gratis"],
  },
  {
    slug: "quadratic-solver-calculator",
    enSlug: "quadratic-solver-calculator",
    name: "Solucionador de Quadratic Equation & Parabola Vertex",
    tagline: "Solucionador de Quadratic Equation & Parabola Vertex online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Solucionador de Quadratic Equation & Parabola Vertex. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["solucionador de quadratic equation & parabola vertex","quadratic equation & parabola vertex solver","quadratic solver calculator","calculadora online gratis"],
  },
  {
    slug: "work-power-calculator",
    enSlug: "work-power-calculator",
    name: "Calculadora de Work, Power & Horsepower Physics",
    tagline: "Calculadora de Work, Power & Horsepower Physics online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Work, Power & Horsepower Physics. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de work, power & horsepower physics","work, power & horsepower physics calculator","work power calculator","calculadora online gratis"],
  },
  {
    slug: "mortgage-refinance-calculator",
    enSlug: "mortgage-refinance-calculator",
    name: "Calculadora de Mortgage Refinance & Break-Even",
    tagline: "Calculadora de Mortgage Refinance & Break-Even online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Mortgage Refinance & Break-Even. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "RefreshCw",
    featured: true,
    keywords: ["calculadora de mortgage refinance & break-even","mortgage refinance & break-even calculator","mortgage refinance calculator","calculadora online gratis"],
  },
  {
    slug: "ideal-body-weight-calculator",
    enSlug: "ideal-body-weight-calculator",
    name: "Calculadora de Ideal Body Weight (IBW)",
    tagline: "Calculadora de Ideal Body Weight (IBW) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Ideal Body Weight (IBW). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculadora de ideal body weight (ibw)","ideal body weight (ibw) calculator","ideal body weight calculator","calculadora online gratis"],
  },
  {
    slug: "fraction-arithmetic-calculator",
    enSlug: "fraction-arithmetic-calculator",
    name: "Calculadora de Fraction & Mixed Number Arithmetic",
    tagline: "Calculadora de Fraction & Mixed Number Arithmetic online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Fraction & Mixed Number Arithmetic. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de fraction & mixed number arithmetic","fraction & mixed number arithmetic calculator","fraction arithmetic calculator","calculadora online gratis"],
  },
  {
    slug: "cagr-calculator",
    enSlug: "cagr-calculator",
    name: "Calculadora de Compound Annual Growth Rate (CAGR)",
    tagline: "Calculadora de Compound Annual Growth Rate (CAGR) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Compound Annual Growth Rate (CAGR). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de compound annual growth rate (cagr)","compound annual growth rate (cagr) calculator","cagr calculator","calculadora online gratis"],
  },
  {
    slug: "wave-speed-calculator",
    enSlug: "wave-speed-calculator",
    name: "Calculadora de Wavelength, Frequency & Wave Speed Physics",
    tagline: "Calculadora de Wavelength, Frequency & Wave Speed Physics online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Wavelength, Frequency & Wave Speed Physics. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de wavelength, frequency & wave speed physics","wavelength, frequency & wave speed physics calculator","wave speed calculator","calculadora online gratis"],
  },
  {
    slug: "dti-calculator",
    enSlug: "dti-calculator",
    name: "Calculadora de Debt-to-Income (DTI) Ratio",
    tagline: "Calculadora de Debt-to-Income (DTI) Ratio online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Debt-to-Income (DTI) Ratio. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["calculadora de debt-to-income (dti) ratio","debt-to-income (dti) ratio calculator","dti calculator","calculadora online gratis"],
  },
  {
    slug: "paycheck-calculator",
    enSlug: "paycheck-calculator",
    name: "Calculadora de Paycheck & Take-Home Pay",
    tagline: "Calculadora de Paycheck & Take-Home Pay online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Paycheck & Take-Home Pay. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Wallet",
    featured: true,
    keywords: ["calculadora de paycheck & take-home pay","paycheck & take-home pay calculator","paycheck calculator","calculadora online gratis"],
  },
  {
    slug: "water-retention-calculator",
    enSlug: "water-retention-calculator",
    name: "Calculadora de Water Weight & Fluid Retention",
    tagline: "Calculadora de Water Weight & Fluid Retention online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Water Weight & Fluid Retention. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Droplets",
    featured: true,
    keywords: ["calculadora de water weight & fluid retention","water weight & fluid retention calculator","water retention calculator","calculadora online gratis"],
  },
  {
    slug: "polynomial-calculator",
    enSlug: "polynomial-calculator",
    name: "Calculadora de Polynomial & Synthetic Division",
    tagline: "Calculadora de Polynomial & Synthetic Division online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Polynomial & Synthetic Division. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de polynomial & synthetic division","polynomial solver & synthetic division calculator","polynomial calculator","calculadora online gratis"],
  },
  {
    slug: "car-depreciation-calculator",
    enSlug: "car-depreciation-calculator",
    name: "Calculadora de Car Depreciation & Resale Value",
    tagline: "Calculadora de Car Depreciation & Resale Value online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Car Depreciation & Resale Value. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Car",
    featured: true,
    keywords: ["calculadora de car depreciation & resale value","car depreciation & resale value calculator","car depreciation calculator","calculadora online gratis"],
  },
  {
    slug: "weighted-gpa-calculator",
    enSlug: "weighted-gpa-calculator",
    name: "Calculadora de Weighted vs Unweighted GPA",
    tagline: "Calculadora de Weighted vs Unweighted GPA online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Weighted vs Unweighted GPA. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculadora de weighted vs unweighted gpa","weighted vs unweighted gpa calculator","weighted gpa calculator","calculadora online gratis"],
  },
  {
    slug: "torque-calculator",
    enSlug: "torque-calculator",
    name: "Calculadora de Torque & Rotational Dynamics Physics",
    tagline: "Calculadora de Torque & Rotational Dynamics Physics online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Torque & Rotational Dynamics Physics. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Unidades y Física",
    icon: "RotateCw",
    featured: true,
    keywords: ["calculadora de torque & rotational dynamics physics","torque & rotational dynamics physics calculator","torque calculator","calculadora online gratis"],
  },
  {
    slug: "half-life-calculator",
    enSlug: "half-life-calculator",
    name: "Calculadora de Radioactive Half-Life & Decay",
    tagline: "Calculadora de Radioactive Half-Life & Decay online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Radioactive Half-Life & Decay. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "Atom",
    featured: true,
    keywords: ["calculadora de radioactive half-life & decay","radioactive half-life & decay calculator","half life calculator","calculadora online gratis"],
  },
  {
    slug: "amortization-schedule-calculator",
    enSlug: "amortization-schedule-calculator",
    name: "Calculadora de Loan & Mortgage Amortization Schedule",
    tagline: "Calculadora de Loan & Mortgage Amortization Schedule online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Loan & Mortgage Amortization Schedule. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Table",
    featured: true,
    keywords: ["calculadora de loan & mortgage amortization schedule","loan & mortgage amortization schedule calculator","amortization schedule calculator","calculadora online gratis"],
  },
  {
    slug: "bmi-percentile-calculator",
    enSlug: "bmi-percentile-calculator",
    name: "Calculadora de Child & Teen BMI Percentile (CDC & WHO)",
    tagline: "Calculadora de Child & Teen BMI Percentile (CDC & WHO) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Child & Teen BMI Percentile (CDC & WHO). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculadora de child & teen bmi percentile (cdc & who)","child & teen bmi percentile calculator (cdc & who)","bmi percentile calculator","calculadora online gratis"],
  },
  {
    slug: "matrix-determinant-calculator",
    enSlug: "matrix-determinant-calculator",
    name: "Calculadora de Matrix Determinant & Transpose",
    tagline: "Calculadora de Matrix Determinant & Transpose online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Matrix Determinant & Transpose. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Grid",
    featured: true,
    keywords: ["calculadora de matrix determinant & transpose","matrix determinant & transpose calculator","matrix determinant calculator","calculadora online gratis"],
  },
  {
    slug: "calories-burned-calculator",
    enSlug: "calories-burned-calculator",
    name: "Calculadora de Exercise Calories Burned & MET",
    tagline: "Calculadora de Exercise Calories Burned & MET online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Exercise Calories Burned & MET. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Salud y Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de exercise calories burned & met","exercise calories burned & met calculator","calories burned calculator","calculadora online gratis"],
  },
  {
    slug: "electricity-cost-calculator",
    enSlug: "electricity-cost-calculator",
    name: "Calculadora de Appliance Electricity & Power Cost",
    tagline: "Calculadora de Appliance Electricity & Power Cost online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Appliance Electricity & Power Cost. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Finanzas y Cotidiano",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de appliance electricity & power cost","appliance electricity & power cost calculator","electricity cost calculator","calculadora online gratis"],
  },
  {
    slug: "dilution-calculator",
    enSlug: "dilution-calculator",
    name: "Calculadora de Solution Dilution (C₁V₁ = C₂V₂)",
    tagline: "Calculadora de Solution Dilution (C₁V₁ = C₂V₂) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Solution Dilution (C₁V₁ = C₂V₂). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de solution dilution (c₁v₁ = c₂v₂)","solution dilution calculator (c₁v₁ = c₂v₂)","dilution calculator","calculadora online gratis"],
  },
  {
    slug: "rc-circuit-calculator",
    enSlug: "rc-circuit-calculator",
    name: "Calculadora de RC Circuit Time Constant (τ = R·C)",
    tagline: "Calculadora de RC Circuit Time Constant (τ = R·C) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de RC Circuit Time Constant (τ = R·C). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Ingeniería y Electrónica",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de rc circuit time constant (τ = r·c)","rc circuit time constant (τ = r·c) calculator","rc circuit calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-semester-calculator",
    enSlug: "gpa-semester-calculator",
    name: "Calculadora de Semester & Term GPA",
    tagline: "Calculadora de Semester & Term GPA online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Semester & Term GPA. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculadora de semester & term gpa","semester & term gpa calculator","gpa semester calculator","calculadora online gratis"],
  },
  {
    slug: "stoichiometry-calculator",
    enSlug: "stoichiometry-calculator",
    name: "Calculadora de Stoichiometry & Theoretical Yield",
    tagline: "Calculadora de Stoichiometry & Theoretical Yield online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Stoichiometry & Theoretical Yield. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de stoichiometry & theoretical yield","stoichiometry & theoretical yield calculator","stoichiometry calculator","calculadora online gratis"],
  },
  {
    slug: "logic-gate-calculator",
    enSlug: "logic-gate-calculator",
    name: "Calculadora de Boolean Logic Gate & Truth Table Generator",
    tagline: "Calculadora de Boolean Logic Gate & Truth Table Generator online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Boolean Logic Gate & Truth Table Generator. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Ingeniería y Electrónica",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de boolean logic gate & truth table generator","boolean logic gate & truth table generator","logic gate calculator","calculadora online gratis"],
  },
  {
    slug: "ellipse-calculator",
    enSlug: "ellipse-calculator",
    name: "Calculadora de Ellipse Area, Perimeter & Foci",
    tagline: "Calculadora de Ellipse Area, Perimeter & Foci online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Ellipse Area, Perimeter & Foci. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Conversión y Geometría",
    icon: "Shapes",
    featured: true,
    keywords: ["calculadora de ellipse area, perimeter & foci","ellipse area, perimeter & foci calculator","ellipse calculator","calculadora online gratis"],
  },
  {
    slug: "buffer-ph-calculator",
    enSlug: "buffer-ph-calculator",
    name: "Calculadora de Henderson-Hasselbalch Buffer pH",
    tagline: "Calculadora de Henderson-Hasselbalch Buffer pH online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Henderson-Hasselbalch Buffer pH. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "TestTube",
    featured: true,
    keywords: ["calculadora de henderson-hasselbalch buffer ph","henderson-hasselbalch buffer ph calculator","buffer ph calculator","calculadora online gratis"],
  },
  {
    slug: "led-resistor-calculator",
    enSlug: "led-resistor-calculator",
    name: "Calculadora de LED Series Current Limiting Resistor",
    tagline: "Calculadora de LED Series Current Limiting Resistor online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de LED Series Current Limiting Resistor. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Ingeniería y Electrónica",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de led series current limiting resistor","led series current limiting resistor calculator","led resistor calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-raise-calculator",
    enSlug: "gpa-raise-calculator",
    name: "Calculadora de GPA Raising & Target Goal",
    tagline: "Calculadora de GPA Raising & Target Goal online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de GPA Raising & Target Goal. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Calificaciones y Educación",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de gpa raising & target goal","gpa raising & target goal calculator","gpa raise calculator","calculadora online gratis"],
  },
  {
    slug: "polynomial-roots-calculator",
    enSlug: "polynomial-roots-calculator",
    name: "Calculadora de Polynomial Roots & Quadratic/Cubic Factoring",
    tagline: "Calculadora de Polynomial Roots & Quadratic/Cubic Factoring online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Polynomial Roots & Quadratic/Cubic Factoring. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Matemáticas y Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de polynomial roots & quadratic/cubic factoring","polynomial roots & quadratic/cubic factoring calculator","polynomial roots calculator","calculadora online gratis"],
  },
  {
    slug: "decibel-calculator",
    enSlug: "decibel-calculator",
    name: "Calculadora de Decibel (dB) Sound & Power Gain",
    tagline: "Calculadora de Decibel (dB) Sound & Power Gain online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Decibel (dB) Sound & Power Gain. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Ingeniería y Electrónica",
    icon: "Volume2",
    featured: true,
    keywords: ["calculadora de decibel (db) sound & power gain","decibel (db) sound & power gain calculator","decibel calculator","calculadora online gratis"],
  },
  {
    slug: "empirical-formula-calculator",
    enSlug: "empirical-formula-calculator",
    name: "Calculadora de Empirical & Molecular Formula Chemistry",
    tagline: "Calculadora de Empirical & Molecular Formula Chemistry online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Empirical & Molecular Formula Chemistry. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Química y Ciencia",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de empirical & molecular formula chemistry","empirical & molecular formula chemistry calculator","empirical formula calculator","calculadora online gratis"],
  },
  {
    slug: "customer-lifetime-value-calculator",
    enSlug: "customer-lifetime-value-calculator",
    name: "Calculadora de Customer Lifetime Value (LTV / CLV)",
    tagline: "Calculadora de Customer Lifetime Value (LTV / CLV) online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Customer Lifetime Value (LTV / CLV). Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "Users",
    featured: true,
    keywords: ["calculadora de customer lifetime value (ltv / clv)","customer lifetime value (ltv / clv) calculator","customer lifetime value calculator","calculadora online gratis"],
  },
  {
    slug: "freelance-hourly-rate-calculator",
    enSlug: "freelance-hourly-rate-calculator",
    name: "Calculadora de Freelance Hourly & Daily Rate",
    tagline: "Calculadora de Freelance Hourly & Daily Rate online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Freelance Hourly & Daily Rate. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "Briefcase",
    featured: true,
    keywords: ["calculadora de freelance hourly & daily rate","freelance hourly & daily rate calculator","freelance hourly rate calculator","calculadora online gratis"],
  },
  {
    slug: "employee-turnover-cost-calculator",
    enSlug: "employee-turnover-cost-calculator",
    name: "Calculadora de Employee Turnover & Replacement Cost",
    tagline: "Calculadora de Employee Turnover & Replacement Cost online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Employee Turnover & Replacement Cost. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "UserMinus",
    featured: true,
    keywords: ["calculadora de employee turnover & replacement cost","employee turnover & replacement cost calculator","employee turnover cost calculator","calculadora online gratis"],
  },
  {
    slug: "customer-acquisition-cost-calculator",
    enSlug: "customer-acquisition-cost-calculator",
    name: "Calculadora de Customer Acquisition Cost (CAC) & Payback",
    tagline: "Calculadora de Customer Acquisition Cost (CAC) & Payback online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Customer Acquisition Cost (CAC) & Payback. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de customer acquisition cost (cac) & payback","customer acquisition cost (cac) & payback calculator","customer acquisition cost calculator","calculadora online gratis"],
  },
  {
    slug: "working-capital-calculator",
    enSlug: "working-capital-calculator",
    name: "Calculadora de Working Capital & Current Ratio",
    tagline: "Calculadora de Working Capital & Current Ratio online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Working Capital & Current Ratio. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "Landmark",
    featured: true,
    keywords: ["calculadora de working capital & current ratio","working capital & current ratio calculator","working capital calculator","calculadora online gratis"],
  },
  {
    slug: "email-open-rate-click-through-calculator",
    enSlug: "email-open-rate-click-through-calculator",
    name: "Calculadora de Email Marketing Open Rate, CTR & Campaign ROI",
    tagline: "Calculadora de Email Marketing Open Rate, CTR & Campaign ROI online y gratis. Cálculo instantáneo con fórmulas y soluciones paso a paso.",
    description: "Calcula fácilmente con Calculadora de Email Marketing Open Rate, CTR & Campaign ROI. Herramienta gratuita en el navegador sin registros ni pérdida de privacidad.",
    category: "Negocios y Productividad",
    icon: "Mail",
    featured: true,
    keywords: ["calculadora de email marketing open rate, ctr & campaign roi","email marketing open rate, ctr & campaign roi calculator","email open rate click through calculator","calculadora online gratis"],
  },
];

export function getEsCalculatorBySlug(slug: string): EsCalculatorMeta | undefined {
  return ES_CALCULATORS.find((c) => c.slug === slug || c.enSlug === slug);
}

export function getEnCalculatorSlugForEsSlug(esSlug: string): string {
  const found = ES_CALCULATORS.find((c) => c.slug === esSlug || c.enSlug === esSlug);
  return found ? found.enSlug : esSlug;
}

export function getEsCalculatorSlugForEnSlug(enSlug: string): string {
  const found = ES_CALCULATORS.find((c) => c.enSlug === enSlug || c.slug === enSlug);
  return found ? found.slug : enSlug;
}

export function relatedEsCalculators(currentSlug: string, count = 4): EsCalculatorMeta[] {
  const current = getEsCalculatorBySlug(currentSlug);
  return ES_CALCULATORS.filter((c) => c.slug !== current?.slug).slice(0, count);
}
